import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';
import { formatDataForDataTable } from '../../utils/formatData';

const initialState = {
  loading: false,
  configData: [],
};

export const createConfig = createAsyncThunk('config/createConfig', async (data) => {
  const res = await apiRequest({
    url: `config/create-config`,
    method: 'post',
    data: data,
  });
  return res;
});

export const getAllConfig = createAsyncThunk('config/getAllConfig', async (data) => {
  const res = await apiRequest({
    url: `config/get-all-config`,
    method: 'get',
    data: data,
  });
  return res;
});

export const updateStatus = createAsyncThunk('config/updateStatus', async (id) => {
  const res = await apiRequest({
    url: `config/update-status/${id}`,
    method: 'patch',
  });
  return res;
});

const cartSlice = createSlice({
  name: 'configSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //.................createConfig..............................
    builder.addCase(createConfig.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(createConfig.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // --------------------------getAllConfig-------------------------

    builder.addCase(getAllConfig.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAllConfig.fulfilled, (state, action) => {
      return {
        ...state,
        configData: action.payload.data,
        loading: false,
      };
    });
    // ------------------updateStatus----------------------------
    builder.addCase(updateStatus.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(updateStatus.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
  },
});

export default cartSlice.reducer;
